"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanStatus = void 0;
exports.canStillAnswer = canStillAnswer;
var PlanStatus;
(function (PlanStatus) {
    PlanStatus["Pending"] = "pending";
    PlanStatus["Complete"] = "complete";
    PlanStatus["Failed"] = "failed";
    PlanStatus["Cancelled"] = "cancelled";
})(PlanStatus || (exports.PlanStatus = PlanStatus = {}));
function canStillAnswer(status) {
    return status === PlanStatus.Pending;
}
//# sourceMappingURL=plan-status.js.map